import { useData } from "data/data-provider";
import { previewDesign } from "lib/devPreview";
import { designBHomeIds, pointsAtMissingSection } from "utils/homeSections";

/**
 * A predicate for the footer and header links: true when the link goes to a home page section
 * Design B does not draw for this tenant, so the link is left out (1NOW-11111). Always false in
 * the other designs, which draw their sections themselves.
 */
export const useHiddenSectionLink = (): ((href: unknown) => boolean) => {
  const { ourCompany, aboutUs, testimonials, whyUs, faqs } = useData();
  if ((previewDesign() || ourCompany?.default_template) !== "design2") return () => false;
  const ids = designBHomeIds({ aboutUs, testimonials, whyUs, faqs });
  return (href) => pointsAtMissingSection(href, ids);
};
